import theme from './theme';
import { appSettings } from './environment/settings';

export default theme;
export { appSettings as baseAppSettings};
